// extracted by mini-css-extract-plugin
export default {"value":"value_value__s5Q7s","notOverflow":"value_notOverflow__0A3dW"};